<ng-container
    *ngIf="
        maxSelection != null &&
        localState?.numSelected === maxSelection &&
        !localState?.dismissedMaxSelection
    "
>
    <div
        class="alert alert-warning justify-content-between insight-grid-alert cmps-cdk-d-flex cmps-cdk-align-items-center"
        role="alert"
    >
        Maximum number of items ({{ maxSelection }}) plotted.
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="localState.dismissedMaxSelection = true"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
</ng-container>
<ng-container *ngIf="_rootRowId && state?.pending.data[_rootRowId]">
    <div class="d-flex justify-content-center">
        <cmps-icon svgIcon="progress-helper"></cmps-icon>
    </div>
</ng-container>
<div
    [class]="'insight-grid ' + className"
    [class.insight-trend-visible]="trendVisible"
    [class.cmps-cdk-d-none]="_rootRowId && state?.pending.data[_rootRowId]"
    [class.cmps-cdk-d-block]="_rootRowId && !state?.pending.data[_rootRowId]"
    #container
></div>

<default-grid #defaultGrid></default-grid>
<default-row #defaultRow></default-row>
<default-cell #defaultCell></default-cell>
<column-element #column></column-element>
<node-element #node></node-element>
<metric-element #metric></metric-element>
